<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lqpqMG/tc-custom/9781426871689.jpg?1718106718253" alt="This image is the cover for the book Contract Bride, Colby Agency"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Contract Bride, Colby Agency
      </h1>
      <p class="bookDescription body article font2">
        <p>Jennifer Ballard never anticipated her wedding day to be an intricate setup. Her fiancé plotted to kill her, then take over her family's pharmaceuticals business--and Jennifer's first instinct was to turn to the prestigious Colby Agency for help. Suddenly she found herself in the protection of Ethan Delaney, the larger-than-life investigator assigned to her case. But in the midst of their clandestine mission to uncover the conspiracy that threatened to destroy her life, Jennifer was unwittingly drawn to her tough-as-nails bodyguard. And now, with only each other to trust, they must overcome danger--and desire--to unravel the dangerous plot designed to destroy Jennifer's life....</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Debra Webb
      </h2>
      
      <p class="authorDescription body article">DEBRA WEBB is the award winning, USA Today bestselling author of more than 170 novels, including reader favorites the Finley O&#39;Sullivan series, the Colby Agency, and the Lookout Mountain Mystery series. With more than four million books sold in numerous languages and countries, Debra&#39;s love of storytelling goes back to her childhood on a farm in Alabama. Visit Debra at www.DebraWebb.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c73246ca